import { Resources } from 'constants/resources';

import { ResourceProps } from 'react-admin';

import { ProviderAccountsCreate } from './ProviderAccountsCreate/ProviderAccountsCreate';
import { ProviderAccountsEdit } from './ProviderAccountsEdit/ProviderAccountsEdit';
import { ProviderAccountsList } from './ProviderAccountsList/ProviderAccountsList';
import { ProviderAccountsShow } from './ProviderAccountsShow/ProviderAccountsShow';

export const providerAccountsResource: ResourceProps = {
  name: Resources.ProviderAccounts,
  create: ProviderAccountsCreate,
  edit: ProviderAccountsEdit,
  list: ProviderAccountsList,
  show: ProviderAccountsShow,
};
